"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromiseLike = exports.isBoolean = exports.isBlob = exports.isFile = exports.isRegExp = exports.isFunction = exports.isArray = void 0;
var toS = Object.prototype.toString;
function isArray(value) {
    return toS.call(value) === '[object Array]';
}
exports.isArray = isArray;
function isFunction(value) {
    return typeof value === 'function';
}
exports.isFunction = isFunction;
function isRegExp(value) {
    return toS.call(value) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
function isFile(value) {
    return toS.call(value) === '[object File]';
}
exports.isFile = isFile;
function isBlob(value) {
    return toS.call(value) === '[object Blob]';
}
exports.isBlob = isBlob;
function isBoolean(value) {
    return typeof value === 'boolean';
}
exports.isBoolean = isBoolean;
function isPromiseLike(value) {
    return value && isFunction(value.then);
}
exports.isPromiseLike = isPromiseLike;
//# sourceMappingURL=isType.js.map